import type { ResourcesConfig } from 'aws-amplify';
import cognitoConfig, { SOCIAL_LOGIN_ENABLED } from '@/config/cognito';

// Check for required environment variables
const missingVars = [];
if (!cognitoConfig.userPoolId) missingVars.push('VITE_USER_POOL_ID');
if (!cognitoConfig.userPoolClientId) missingVars.push('VITE_APP_CLIENT_ID');
if (!cognitoConfig.userPoolRegion) missingVars.push('VITE_REGION');
if (SOCIAL_LOGIN_ENABLED && !cognitoConfig.domain) missingVars.push('VITE_COGNITO_DOMAIN');

if (missingVars.length > 0) {
  throw new Error(`Required environment variables are not set: ${missingVars.join(', ')}`);
}

/** Origins Cognito must allow; Amplify picks the current origin at runtime. */
/** Must match Cognito app-client callback and sign-out URLs exactly (trailing slash). */
const oauthRedirects = ['http://localhost:3000/', 'https://my.we-tree.app/'] as const;

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
      identityPoolId: '',
      region: cognitoConfig.userPoolRegion,
      loginWith: {
        email: true,
        ...(SOCIAL_LOGIN_ENABLED && cognitoConfig.domain
          ? {
              oauth: {
                domain: cognitoConfig.domain,
                scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
                redirectSignIn: [...oauthRedirects],
                redirectSignOut: [...oauthRedirects],
                responseType: 'code' as const
              }
            }
          : {})
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        nickname: {
          required: true
        }
      },
      allowGuestAccess: true,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true
      }
    }
  }
};

export default amplifyConfig as ResourcesConfig;
